import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { AuthGuard } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EquipmentAssetComponent } from './equipment-asset.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FiltersModule } from 'src/app/filters/filters.module';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'equipment-asset/:categoryId/:productTypeId',
        component: EquipmentAssetComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'equipment-asset/:categoryId/:productTypeId/:statusFilter',
        component: EquipmentAssetComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'equipment-unavailable-asset/:categoryId/:productTypeId/:statusFilter/:unavailableStatus',
        component: EquipmentAssetComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'equipment-unavailable-asset/:categoryId/:productTypeId/:statusFilter',
        component: EquipmentAssetComponent,
        canActivate: [AuthGuard],
      },
    ]),
    CommonModule,
    CoreModule,
    MatTooltipModule,
    InfiniteScrollModule,
    FiltersModule,
  ],
  providers: [],
  declarations: [EquipmentAssetComponent],
})
export class EquipmentAssetModule {}
